/*
<summary>
   This functional component is all about rendering the Step 1-4 progress stepper for the
   Add/Edit Product form, driven by the actual currentStep so completed steps always show a
   tick and the current/future steps always show their plain number.
   Developer: Aashish Singh, Created Date: 14-Oct-2026
</summary>
<param>No Parameter Passed</param>
<returns>Returns JSX</returns>
*/

import { FormattedMessage } from 'react-intl';
import { RoundTabIcon } from '../../../shared-components/svgs/svgs';

interface IProps {
  currentStep: 1 | 2 | 3 | 4;
}

const steps = [1, 2, 3, 4] as const;

const ProductStepper = ({ currentStep }: IProps) => {
  return (
    <div className="wizard overflow-hidden">
      <div className="wizard-inner">
        <div className="connecting-line"></div>
        <ul
          className="nav nav-tabs"
          role="tablist"
        >
          {steps.map((step) => (
            <li
              key={step}
              role="presentation"
              className={step <= currentStep ? 'active' : 'disabled'}
            >
              <a
                data-toggle="tab"
                aria-controls={`step${step}`}
                role="tab"
                aria-expanded={step === currentStep}
              >
                <span className="round-tab">
                  {step < currentStep ? <RoundTabIcon /> : step}
                </span>
                <i><FormattedMessage id={`step${step}`} /></i>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ProductStepper;
